import { getPrimaryTracker } from 'usage-tracker-container';
import { COOKIE_ECHO_USER } from 'pricing-pages-api/EarlyRequesterNames';
import { GET_COOKIE_AUTH } from 'pricing-pages-api/user/queries';
import { dataFetchingClient } from 'pricing-pages-ui/utils/dataFetchingClient';
const HUBSPOT_DOMAIN = '@hubspot.com';
export function fetchUserData() {
  dataFetchingClient.query({
    query: GET_COOKIE_AUTH,
    variables: {
      earlyRequestName: COOKIE_ECHO_USER
    }
  }).then(response => {
    var _response$data$cookie, _response$data;
    const email = (_response$data$cookie = (_response$data = response.data) === null || _response$data === void 0 || (_response$data = _response$data.cookieAuth) === null || _response$data === void 0 ? void 0 : _response$data.email) !== null && _response$data$cookie !== void 0 ? _response$data$cookie : '';
    getPrimaryTracker().setProperties({
      isHubSpotter: email.endsWith(HUBSPOT_DOMAIN)
    });
  }).catch(() => {
    // no op
  });
}